import { Elements } from '@stripe/react-stripe-js';
import { useLocation } from 'react-router-dom';
import { default as ConfirmOrderComponent } from './ConfirmOrder';
import StripeWrapper from './StripeWrapper';

const ELEMENTS_APPEARANCE = {
  theme: 'none',
  labels: 'floating',
  variables: {
    colorPrimary: 'rgb(83, 219, 214)',
    colorBackground: '#242629',
    colorText: 'white',
    colorDanger: 'rgba(235, 56, 96, 1)'
  },
  rules: {
    '.Input': {
      border: '1px solid rgba(0, 0, 0, 1)',
      backgroundColor: '#000',
      color: '#FFF',
      cursor: 'pointer'
    },

    '.Input:focus': {
      outline: '0px',
      border: '1px solid rgba(83, 219, 214, 1)'
    },

    '.Input--invalid': {
      border: '1px solid rgba(235, 56, 96, 1)'
    },

    '.Label': {
      color: '#FFF'
    },

    '.Label--resting': {
      color: '#7e8184'
    },

    '.Label--floating': {
      color: 'rgba(83, 219, 214, 1)'
    },

    '.Tab': {
      border: '2px solid rgba(174, 174, 174, .5)',
      color: 'rgba(255, 255, 255, .8)',
      borderRadius: '10px',
      backgroundColor: 'transparent',
      opacity: '1'
    },

    '.Tab--selected': {
      border: '2px solid rgba(83, 219, 214,1)',
      color: '#FFF',
      backgroundColor: 'rgba(0,0,0,1)'
    },

    '.TabIcon--selected': {
      opacity: '1'
    }
  }
};

const ConfirmOrder = (props) => {
  const { state } = useLocation();
  if (state && state.clientSecret) {
    return (
      <Elements
        stripe={props.stripePromise}
        options={{
          clientSecret: state.clientSecret,
          appearance: ELEMENTS_APPEARANCE,
          loader: 'always'
        }}
      >
        <StripeWrapper {...props}>
          <ConfirmOrderComponent />
        </StripeWrapper>
      </Elements>
    );
  } else {
    return <ConfirmOrderComponent {...props} />;
  }
};

export default ConfirmOrder;
